export const careData = [
  {
    title: "Pokkot",
    link: "pokkot",
  },
  {
    title: "Kimchi",
    link: "kimchi",
  },
];
